import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import Icons from "shared/icons";
import NavbarItems from "../NavbarItems/NavbarItems";

// TODO Decomposition

function ScrollableNavbarItems() {
  const [showScrollBtns, setShowScrollBtns] = useState(false);

  const navItemsRef = useRef(null);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (navItemsRef.current) {
        const { scrollWidth, clientWidth } = navItemsRef.current;
        setShowScrollBtns(clientWidth < scrollWidth);
      }
    });

    if (navItemsRef.current) {
      resizeObserver.observe(navItemsRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const handleScrollLeft = () => {
    navItemsRef.current.scrollLeft -= 90;
  };
  const handleScrollRight = () => {
    navItemsRef.current.scrollLeft += 90;
  };

  return (
    <Box
      className="nav-items__container"
      sx={{
        display: { xs: "none", md: "flex" },
      }}
    >
      {showScrollBtns && (
        <IconButton
          size="large"
          aria-label="scroll-left"
          onClick={handleScrollLeft}
          sx={{
            color: "white",
            position: "absolute",
            fontSize: "0.9rem",
            height: "50px",
            width: "50px",
            left: "-1px",
            background:
              "linear-gradient(90deg, rgb(0, 38, 100, 1), rgba(0, 38, 100, 0.95), rgb(0, 38, 100, 0.1))",
            "&:hover": {
              background:
                "linear-gradient(90deg, rgb(0, 38, 100, 1), rgba(0, 38, 100, 0.95), rgb(0, 38, 100, 0.1))",
            },
            display: {
              xs: "none",
              sm: "inline-flex",
            },
          }}
        >
          <FontAwesomeIcon icon={Icons.chevronLeft} />
        </IconButton>
      )}
      <Box className="nav-items" ref={navItemsRef}>
        <NavbarItems />
      </Box>
      {showScrollBtns && (
        <IconButton
          size="large"
          aria-label="scroll-right"
          onClick={handleScrollRight}
          sx={{
            ml: 1,
            color: "white",
            position: "absolute",
            right: "-1px",
            fontSize: "0.9rem",
            height: "50px",
            width: "50px",
            background:
              "linear-gradient(90deg, rgb(0, 38, 100, 0.1), rgba(0, 38, 100, 0.95), rgb(0, 38, 100, 1))",
            "&:hover": {
              background:
                "linear-gradient(90deg, rgb(0, 38, 100, 0.1), rgba(0, 38, 100, 0.95), rgb(0, 38, 100, 1))",
            },
            display: {
              xs: "none",
              sm: "inline-flex",
            },
          }}
        >
          <FontAwesomeIcon icon={Icons.chevronRight} />
        </IconButton>
      )}
    </Box>
  );
}

export default ScrollableNavbarItems;
